import { useState } from "react";
import { usePageTitle } from "context/PageTitleContext";

import useGetCurrentCourses from "hooks/useGetCurrentCourses";
import useEmailer from "hooks/useEmailer";
import useSelectedStudent from "hooks/useSelectedStudent";
import CourseItem from "components/Courses/CourseItem";
import Modal from "components/Modal";

import styles from "./Courses.module.css";

const Courses = () => {
    usePageTitle("Courses");

    const { selectedStudentId } = useSelectedStudent();

    const { courses, isLoading } = useGetCurrentCourses({ selectedStudentId });
    const [onEmail, isSending, isSuccess] = useEmailer();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [emailTo, setEmailTo] = useState("");

    return (
        <>
            {isLoading ? (
                <p>Loading...</p>
            ) : (
                <ul className={styles.currentCoursesList}>
                    {courses?.map((course) => (
                        <CourseItem
                            key={course.id}
                            course={course}
                            isCurrent
                            setIsModalOpen={setIsModalOpen}
                            setEmailTo={setEmailTo}
                        />
                    ))}
                </ul>
            )}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <h2 className={styles.contactFormTitle}>Contact Teacher</h2>
                <form
                    className={styles.contactForm}
                    onSubmit={(e) => {
                        e.preventDefault();
                        onEmail({
                            recipients: e.target.recipients.value
                                .split(",")
                                .map((email) => ({
                                    emailAddress: { address: email },
                                })),
                            subject: e.target.subject.value,
                            body: e.target.message.value,
                        });
                    }}
                >
                    <p>Email To:</p>
                    <input
                        type="text"
                        name="recipients"
                        required
                        value={emailTo}
                        onChange={(e) => setEmailTo(e.target.value)}
                    />
                    <p>Subject:</p>
                    <input type="text" name="subject" required />
                    <p>Message:</p>
                    <textarea name="message" rows="5" required></textarea>
                    {isSending ? (
                        <p>Sending...</p>
                    ) : (
                        isSuccess && <p>Email sent!</p>
                    )}
                    <button type="submit">Send</button>
                </form>
            </Modal>
        </>
    );
};

export default Courses;
